const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);


// sections in DOM order
const sections = document.querySelectorAll('section');

// things to show
const info  = document.querySelector('.info');
const excerpt = document.querySelector('.excerpt');
const fig1  = document.querySelector('.figure-1');
const fig2  = document.querySelector('.figure-2');
const header = document.querySelector('header');
const emailLink = document.querySelector('a[href^="mailto:"]');
const newsLink = document.querySelector('a.news-link');

const targets = [info, excerpt, fig1, fig2];
const peopleSection = document.querySelector('section.people');
const newsSection = document.querySelector('section.news');
const newsIndex = newsSection ? Array.prototype.indexOf.call(sections, newsSection) : -1;
const personInfoEls = Array.from(document.querySelectorAll('.person-info'));

function hideAll() {
  targets.forEach(el => {
    if (!el) return;
    el.style.display = 'none';
  });
  if (personInfoEls.length) {
    personInfoEls.forEach(el => (el.style.display = 'none'));
  }
}

// put element at a random position, with the constraints you described
function positionRandomly(el, width, height) {
  const padding = 100; // distance from window edges
  const headerBottom = header ? header.offsetHeight : 0;

  // limit height to half viewport
  const maxHeight = Math.min(height, window.innerHeight / 2);
  const maxWidth  = Math.min(width,  window.innerWidth - padding * 2);

  const safeHeight = maxHeight;
  const safeWidth  = maxWidth;

  let minLeft = 630;
  let maxLeft = window.innerWidth - safeWidth - padding;

  if (maxLeft < minLeft) {
    // fallback: just centre horizontally
    minLeft = maxLeft = (window.innerWidth - safeWidth) / 2;
  }

  let minTop = padding;
  let maxTop = window.innerHeight - safeHeight - padding;

  if (maxTop < minTop) {
    // fallback: centre vertically under header
    minTop = maxTop = Math.max(minTop, (window.innerHeight - safeHeight) / 2);
  }

  const left = minLeft + Math.random() * (maxLeft - minLeft);
  const top  = minTop + Math.random() * (maxTop - minTop);

  el.style.position = 'fixed';
  el.style.left = `${left}px`;
  el.style.top  = `${top}px`;
//   el.style.transform = 'rotate(' + (Math.random() * 4 - 2) + 'deg)';
}

// size helper for figures (fixed placement)
function showFigure(figure) {
  if (!figure) return;

  const img = figure.querySelector('img');
  let imgW = 300;
  let imgH = 300;

  if (img) {
    imgW = parseInt(img.getAttribute('width'))  || img.naturalWidth  || img.offsetWidth  || imgW;
    imgH = parseInt(img.getAttribute('height')) || img.naturalHeight || img.offsetHeight || imgH;

    // clamp height to half viewport and not bigger than intrinsic
    const targetH = Math.min(imgH, window.innerHeight / 2);
    const scale = targetH / imgH;
    const targetW = imgW * scale;

    img.style.width  = `${targetW}px`;
    img.style.height = `${targetH}px`;

    figure.style.width  = `${targetW}px`;
    figure.style.height = `${targetH}px`;

    figure.style.display = 'block';
    figure.style.position = 'fixed';
    figure.style.top = '10vw';
    figure.style.right = '10vw';
    figure.style.left = 'auto';
  } else {
    // no img: just use its current box
    figure.style.display = 'block';
    figure.style.position = 'fixed';
    figure.style.top = '10vw';
    figure.style.right = '10vw';
    figure.style.left = 'auto';
  }
}

// size + position helper for .info
function showInfoRandomly(infoEl) {
  if (!infoEl) return;

  // temporarily show to measure
  const prevDisplay = infoEl.style.display;
  const prevVis = infoEl.style.visibility;

  infoEl.style.visibility = 'hidden';
  infoEl.style.display = 'block';

  const rect = infoEl.getBoundingClientRect();
  const width = rect.width;
  const height = rect.height;

  infoEl.style.visibility = prevVis;
  infoEl.style.display = 'block';

  // optionally cap height if it is taller than half window
  const maxH = Math.min(height, window.innerHeight / 2);
  infoEl.style.maxHeight = `${maxH}px`;

  if (isMobile) {
    positionRandomly(infoEl, width, maxH);
  }
}

// start hidden
hideAll();

let activeIndex = null;

// DESKTOP / POINTER HOVER LOGIC
// DESKTOP / POINTER HOVER LOGIC
if (!isMobile) {
  sections.forEach((section, index) => {
    section.addEventListener('mouseenter', () => {
      if (section.classList.contains('people')) return;
      if (activeIndex === index) return;
      activeIndex = index;
      hideAll();

      sections.forEach((s, i) => {
        s.style.opacity = i === index ? '1' : '0';
      });

      if (index === 0) showInfoRandomly(info);
      else if (index === 1) showFigure(fig1);
      else if (index === 2) showFigure(fig2);
      else if (index === newsIndex) showInfoRandomly(excerpt);
    });

    section.addEventListener('mouseleave', (e) => {
      const related = e.relatedTarget;
      if (related && related.closest) {
        const relatedSection = related.closest('section');
        if (relatedSection && !relatedSection.classList.contains('people')) return;
      }
      activeIndex = null;
      hideAll();
      sections.forEach(s => (s.style.opacity = '1'));
    });
  });
}

// PEOPLE HOVER INFO (desktop only)
const personInfoById = new Map(
  personInfoEls.map(el => [el.getAttribute('data-person-id'), el])
);

function showPersonInfo(id) {
  hidePersonInfo();
  const el = personInfoById.get(id);
  if (!el) return;
  showInfoRandomly(el);
}

function hidePersonInfo() {
  personInfoEls.forEach(el => (el.style.display = 'none'));
}

// MOBILE TOUCH LOGIC (just show/hide, no layout / size work)
// MOBILE TOUCH LOGIC (just show/hide, no layout / size work)
if (isMobile) {
  function mobileHideAll() {
    hideAll();
    sections.forEach(s => (s.style.opacity = '1'));
    activeIndex = null;
    activeTouchId = null;
  }

  function mobileShow(index) {
    if (index === activeIndex) return;

    hideAll();
    activeIndex = index;

    // hide other sections same as desktop
    sections.forEach((s, i) => {
      s.style.opacity = i === index ? '1' : '0';
    });

    if (index === 0 && info) info.style.display = 'block';
    else if (index === 1 && fig1) fig1.style.display = 'block';
    else if (index === 2 && fig2) fig2.style.display = 'block';
    else if (index === newsIndex && excerpt) excerpt.style.display = 'block';
  }

  let activeTouchId = null;


  sections.forEach((section, index) => {
    section.addEventListener('touchstart', (e) => {
      if (section.classList.contains('people')) {
        const span = e.target.closest && e.target.closest('section.people span');
        if (!span) return;
      }
      const t = e.changedTouches[0];
      activeTouchId = t.identifier;
      mobileShow(index);
    }, { passive: true });
  });

  let activePeopleSpan = null;
  const peopleIndex = peopleSection ? Array.prototype.indexOf.call(sections, peopleSection) : -1;

  function setActivePeopleSpan(span, options = {}) {
    if (activePeopleSpan === span) return;
    if (peopleSection) {
      const spans = peopleSection.querySelectorAll('span');
      spans.forEach(s => s.classList.remove('is-active'));
    }
    activePeopleSpan = span;
    if (!span) {
      if (peopleSection) peopleSection.classList.remove('is-hovering');
      if (!options.suppressReset && peopleIndex !== -1) {
        activeIndex = null;
        sections.forEach(s => (s.style.opacity = '1'));
      }
      hidePersonInfo();
      return;
    }
    if (peopleSection) peopleSection.classList.add('is-hovering');
    span.classList.add('is-active');
    if (peopleIndex !== -1) {
      activeIndex = peopleIndex;
      hideAll();
      sections.forEach((s, i) => {
        s.style.opacity = i === peopleIndex ? '1' : '0';
      });
    }
    const id = span.getAttribute('data-person-id');
    if (id) showPersonInfo(id);
  }

  window.addEventListener('touchmove', (e) => {
    if (activeTouchId === null) return;

    let touch = null;
    for (let i = 0; i < e.changedTouches.length; i++) {
      if (e.changedTouches[i].identifier === activeTouchId) {
        touch = e.changedTouches[i];
        break;
      }
    }
    if (!touch) return;

    const el = document.elementFromPoint(touch.clientX, touch.clientY);
    if (!el) return;

    const peopleSpan = el.closest && el.closest('section.people span');
    const section = el.closest && el.closest('section');
    if (!section) return;

    if (section === peopleSection) {
      if (peopleSpan) setActivePeopleSpan(peopleSpan);
      // if between spans, keep current active to avoid flicker
      return;
    }

    setActivePeopleSpan(null, { suppressReset: true });
    const newIndex = Array.prototype.indexOf.call(sections, section);
    if (newIndex !== -1) mobileShow(newIndex);
  }, { passive: true });

  window.addEventListener('touchend', (e) => {
    if (activeTouchId === null) return;
    for (let i = 0; i < e.changedTouches.length; i++) {
      if (e.changedTouches[i].identifier === activeTouchId) {
        mobileHideAll();
        if (peopleSection) {
          peopleSection.classList.remove('is-hovering');
          const spans = peopleSection.querySelectorAll('span');
          spans.forEach(s => s.classList.remove('is-active'));
        }
        hidePersonInfo();
        break;
      }
    }
  });

  window.addEventListener('touchcancel', () => {
    if (peopleSection) {
      peopleSection.classList.remove('is-hovering');
      const spans = peopleSection.querySelectorAll('span');
      spans.forEach(s => s.classList.remove('is-active'));
    }
    hidePersonInfo();
    mobileHideAll();
  });

  // tap anywhere else to reset (prevents "stuck" overlays)
  document.addEventListener('touchstart', (e) => {
    const inSection = e.target.closest && e.target.closest('section');
    if (!inSection) {
      if (peopleSection) {
        peopleSection.classList.remove('is-hovering');
        const spans = peopleSection.querySelectorAll('span');
        spans.forEach(s => s.classList.remove('is-active'));
      }
      hidePersonInfo();
      mobileHideAll();
      return;
    }
    const peopleSpan = e.target.closest && e.target.closest('section.people span');
    if (inSection === peopleSection) {
      if (peopleSpan) {
        setActivePeopleSpan(peopleSpan);
      }
      return;
    }

    setActivePeopleSpan(null, { suppressReset: true });
    const newIndex = Array.prototype.indexOf.call(sections, inSection);
    if (newIndex !== -1) mobileShow(newIndex);
  }, { passive: true });
}

document.addEventListener('click', function (e) {
  if (!isMobile) return;
  if (e.target && e.target.closest && e.target.closest('a[href^="mailto:"]')) return;
  if (e.target && e.target.closest && e.target.closest('a.news-link')) return;
  e.preventDefault();
}, true);

// email copy behavior
if (emailLink) {
  let emailCopiedOnce = false;
  let emailResetTimer = null;
  const originalEmailText = emailLink.textContent;
  const emailAddress = emailLink.getAttribute('href').replace(/^mailto:/i, '');

  async function copyEmail(e) {
    e.preventDefault();
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(emailAddress);
      } else {
        const ta = document.createElement('textarea');
        ta.value = emailAddress;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
    } catch (_) {
      // ignore copy failures, still show feedback
    }
    emailLink.textContent = 'email copied to clipboard';
    if (emailResetTimer) clearTimeout(emailResetTimer);
    emailResetTimer = setTimeout(() => {
      emailLink.textContent = originalEmailText;
    }, 3000);
  }

  if (!isMobile) {
    emailLink.addEventListener('click', (e) => {
      if (emailCopiedOnce) return;
      emailCopiedOnce = true;
      copyEmail(e);
    });
  } else {
    // mobile: only when tapping the link itself
    emailLink.addEventListener('click', (e) => {
      copyEmail(e);
      e.stopPropagation();
    });
  }
}

if (newsLink && isMobile) {
  let newsCopiedOnce = false;
  let newsResetTimer = null;
  const originalNewsHtml = newsLink.innerHTML;
  const newsHref = newsLink.getAttribute('href') || '';

  async function copyNewsLink(e) {
    e.preventDefault();
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(newsHref);
      } else {
        const ta = document.createElement('textarea');
        ta.value = newsHref;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
    } catch (_) {
      // ignore copy failures, still show feedback
    }
    newsLink.textContent = 'link copied to clipboard';
    if (newsResetTimer) clearTimeout(newsResetTimer);
    newsResetTimer = setTimeout(() => {
      newsLink.innerHTML = originalNewsHtml;
    }, 3000);
  }

  newsLink.addEventListener('click', (e) => {
    if (newsCopiedOnce) {
      e.stopPropagation();
      return;
    }
    newsCopiedOnce = true;
    copyNewsLink(e);
    e.stopPropagation();
  });
}

if (!isMobile) {
  if (peopleSection) {
    const peopleSpans = Array.from(peopleSection.querySelectorAll('span'));
    let activeSpan = null;
    const peopleIndex = Array.prototype.indexOf.call(sections, peopleSection);

    function setActiveSpan(span, options = {}) {
      if (activeSpan === span) return;
      peopleSpans.forEach(s => s.classList.remove('is-active'));
      activeSpan = span;
      if (!span) {
        peopleSection.classList.remove('is-hovering');
        hidePersonInfo();
        if (!options.suppressReset) {
          activeIndex = null;
          sections.forEach(s => (s.style.opacity = '1'));
        }
        return;
      }
      peopleSection.classList.add('is-hovering');
      span.classList.add('is-active');
      if (peopleIndex !== -1) {
        activeIndex = peopleIndex;
        hideAll();
        sections.forEach((s, i) => {
          s.style.opacity = i === peopleIndex ? '1' : '0';
        });
      }
      const id = span.getAttribute('data-person-id');
      if (id) showPersonInfo(id);
    }

    peopleSection.addEventListener('mousemove', (e) => {
      const el = document.elementFromPoint(e.clientX, e.clientY);
      const span = el && el.closest && el.closest('section.people span');
      if (span) {
        setActiveSpan(span);
      }
    });

    peopleSection.addEventListener('mouseleave', (e) => {
      const related = e.relatedTarget;
      const nextSection = related && related.closest && related.closest('section');
      if (nextSection && !nextSection.classList.contains('people')) {
        requestAnimationFrame(() => {
          if (activeIndex !== peopleIndex) {
            setActiveSpan(null, { suppressReset: true });
          }
        });
        return;
      }
      setActiveSpan(null);
    });
  }
}
